export interface CoreGoogleDevice {
    deviceId: string
    serialNumber: string
    status: GoogleDeviceStatus
    lastSync?: string
    model: string
    osVersion: string
    lastEnrollmentTime?: string
    recentUser?: CoreGoogleDeviceRecentUser
    lastKnownNetwork: boolean
    orgUnitPath: string
    autoUpdateExpiration?: string
    active: boolean
    created: string
    modified: string
    removed: string
    id: string
    recentUsers?: CoreGoogleDeviceRecentUser[]
    users?: CoreGoogleDeviceUser[]
    annotatedAssetId?: string
    annotatedLocation?: string
    notes?: string
    annotatedUser?: string
}

export enum GoogleDeviceStatus {
    Unknown = 0,
    Active = 1,
    Delinquent = 2,
    Pre_Provisioned = 3,
    Deprovisioned = 4,
    Disabled = 5,
    Inactive = 6,
    Return_Arrived = 7,
    Return_Requested = 8,
    Shipped = 9,
}

export interface CoreGoogleDeviceRecentUser {
    emailAddress: string
    googleId: string
    orgUnitPath: string
    type: GoogleDeviceRecentUserType
    sortIndex: number
}

export enum GoogleDeviceRecentUserType {
    Unknown = 0,
    USER_TYPE_MANAGED = 1,
    USER_TYPE_UNMANAGED = 2
}

export interface CoreGoogleDeviceLastKnownNetwork {
    ipAddress: string
    wanIpAddress: string
}

export interface CoreGoogleDeviceUser {
    userId: string
    userDisplayName?: string
    active: boolean
    created: string
    removed?: string
}

export interface CoreGoogleDeviceDashboard {
    approvedVersions: string[]
    activeDevices: number
    inactiveDevices: number
    osVersionPercent: number
    autoUpdateExpiration: number
    lastSync: number
}

export interface GoogleDeviceStatusCount {
    status: number
    count: number
}

export interface GoogleDeviceCount {
    name: string
    count: number
}

export enum GoogleDeviceAutoUpdateExpiration {
    Expired = "expired",
    HalfYear = "0-180",
    Year1 = "181-365",
    Year1To2 = "1-2",
    Year2To3 = "2-3",
    Year3Plus = "3+",
    Missing = "missing"
}

export enum GoogleDeviceLastSync {
    Thirty = 30,
    Sixty = 60,
    Ninety = 90
}